import player14 from '@assets/players/14.webp';
import player9 from '@assets/players/9.webp';
import player11 from '@assets/players/11.webp';
import player8 from '@assets/players/8.webp';
import player25 from '@assets/players/25.webp';
import player10 from '@assets/players/10.webp';
import player2 from '@assets/players/2.webp';
import player4 from '@assets/players/4.webp';
import player5 from '@assets/players/5.webp';
import player12 from '@assets/players/12.webp';
import player1 from '@assets/players/1.webp';

const pitch = [
    {
        number: 14,
        avatar: player14,
        role: 'left-winger',
        name: 'Casemiro'
    },
    {
        number: 9,
        avatar: player9,
        role: 'center-forward',
        name: 'Benzema'
    },
    {
        number: 11,
        avatar: player11,
        role: 'right-winger',
        name: 'Bale'
    },
    {
        number: 8,
        avatar: player8,
        role: 'center-midfielder-left',
        name: 'Kross'
    },
    {
        number: 25,
        avatar: player25,
        role: 'center-midfielder-center',
        name: 'Junior'
    },
    {
        number: 10,
        avatar: player10,
        role: 'center-midfielder-right',
        name: 'Modric'
    },
    {
        number: 2,
        avatar: player2,
        role: 'full-back-left',
        name: 'Carvajal'
    },
    {
        number: 4,
        avatar: player4,
        role: 'center-back-left',
        name: 'Ramos'
    },
    {
        number: 5,
        avatar: player5,
        role: 'center-back-right',
        name: 'Varane'
    },
    {
        number: 12,
        avatar: player12,
        role: 'full-back-right',
        name: 'Marcelo'
    },
    {
        number: 1,
        avatar: player1,
        role: 'keeper',
        name: 'Courtois'
    }
]

export default pitch